export default __webpack_public_path__ + "static/Idorenyin-7b011cd0a4dd3d5ac01c66590154aca9.png";